<div class="header">
    <div class="logo logo-dark" style="display: flex; justify-content: center; align-items: center;">
        <a href="">
            <img src="assets/images/logo/_equip.png" alt="Logo">
            <!-- <img class="logo-fold" src="assets/images/logo/logo-fold.png" alt="Logo"> -->
        </a>
    </div>
    <!-- <div class="logo logo-white">
        <a href="">
            <img src="assets/images/logo/logo-white.png" alt="Logo">
            <img class="logo-fold" src="assets/images/logo/logo-fold-white.png" alt="Logo">
        </a>
    </div> -->
    <div class="nav-wrap">
        <ul class="nav-left">
            <li class="desktop-toggle">
                <a (click)="toggleFold()">
                    <i nz-icon [nzType]="isFolded? 'menu-unfold':'menu-fold'" theme="outline"></i>
                </a>
            </li>
            <li class="mobile-toggle">
                <a (click)="toggleExpand()">
                    <i nz-icon [nzType]="isExpand? 'menu-fold': 'menu-unfold'" theme="outline"></i>
                </a>
            </li>
            <!-- comment the Search section ondt 11052024  -->
            <!-- <li>
                <a (click)="searchToggle()">
                    <i nz-icon nzType="search" theme="outline"></i>
                </a>
                <nz-drawer [nzWidth]="380" nzTitle="Search" [nzVisible]="searchVisible" nzPlacement="left" (nzOnClose)="searchToggle()">
                    <app-search></app-search>
                </nz-drawer>
            </li> -->
        </ul>
        <ul class="nav-right">
            <li>
                <div class="d-flex">
                    <nz-avatar nzSize="large" nzIcon="user"></nz-avatar>
                    <!-- <nz-avatar nzSize="large" nzSrc="assets/images/avatars/thumb-3.jpg"></nz-avatar> -->
                    <div class="m-l-15" style="display: flex; ">
                        <p class="m-b-0 font-weight-semibold font-22" style="color: #2D2D35; display: flex; align-items: center;"><b>Hello,  Admin</b></p>
                        <!-- <p class="m-b-0 font-11" style="color: #000000">Park Place Apartment Homes</p> -->
                    </div>
                    <span class="p-h-10 pointer" nz-dropdown [nzDropdownMenu]="profile" [nzTrigger]="'click'"
                        [nzPlacement]="'bottomRight'" style="position: relative;top: 0px; display: flex; align-items: center;">
                        <i nz-icon nzType="caret-down" nzTheme="outline"></i>
                    </span>
                </div>
                <nz-dropdown-menu #profile="nzDropdownMenu">
                    <ul nz-menu class="">
                        <li nz-menu-item class="addhovereffect">
                            <a class="p-v-5 d-flex align-items-center justify-content-between" (click)="showConfirm()">
                                <div>
                                    <span class="m-l-10 font-small-caps">
                                        <span nz-icon nzType="logout" nzTheme="outline" class="p-l-4" style="margin-right: 5px;"></span> 
                                        Logout
                                    </span>
                                </div>
                            </a>
                        </li>
                    </ul>
                </nz-dropdown-menu>
            </li>
        </ul>
    </div>
</div>    